(function(){
function go(){
  var g=document.querySelector('#product-grid');if(!g)return;
  var items=[].slice.call(g.children),sold=[];
  items.forEach(function(li){var b=li.querySelector('.badge');if(b&&/sold out/i.test(b.textContent)){li.classList.add('pk-soldli');sold.push(li)}});
  sold.forEach(function(li){g.appendChild(li)});
}
if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
})();
(function(){
  if(/\/collections\/all\/?$/.test(location.pathname)&&!/sort_by=/.test(location.search)){
    var u=new URL(location.href);u.searchParams.set('sort_by','best-selling');location.replace(u.toString());
  }
})();
(function(){
  if(!/-universe\/?$/.test(location.pathname))return;
  function go(){
    var g=document.querySelector('#product-grid');if(!g)return;
    [].slice.call(g.children).forEach(function(li){
      var b=li.querySelector('.badge'),t=li.querySelector('.card__heading');
      if(b&&/sold out/i.test(b.textContent)&&t&&/deck/i.test(t.textContent))li.remove();
    });
  }
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
})();
